import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'underscore'
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker.js';
 
ReactDOM.render(<App />, document.getElementById('root'));
 
serviceWorker.unregister();